import { defineComponent, inject, ref, reactive, watch, nextTick, onMounted, openBlock, createElementBlock, normalizeClass, createElementVNode, withDirectives, withKeys, vModelText, createBlock, resolveDynamicComponent, unref, withCtx, createVNode, toDisplayString, Fragment, renderList, Teleport, withModifiers, createCommentVNode, createTextVNode, vShow } from 'vue';
import { getPublishTimestamp } from '../../utils/index.mjs';
import TvbSearchGreyIcon from '../Icon/SearchGrey.vue.mjs';
import TvbSearchGreyMIcon from '../Icon/SearchGreyM.vue.mjs';
import TvbSearchWhiteIcon from '../Icon/SearchWhite.vue.mjs';
import request from '../../utils/request.mjs';
import { PUBLIC_URL, API_BASE } from '../../utils/getConstant.mjs';
import { useClickOutside } from '../../hooks/useClickOutside/index.mjs';
import TvbLogoIcon from '../Icon/Logo.vue.mjs';
import TvbClearIcon from '../Icon/Clear.vue.mjs';

const _hoisted_1 = ["placeholder"];
const _hoisted_2 = ["href", "title", "onClick", "innerHTML"];
const _hoisted_3 = { class: "tvb-mobile-search-input" };
const _hoisted_4 = ["placeholder"];
const _hoisted_5 = ["href", "title", "onClick"];
const _hoisted_6 = ["innerHTML"];
const __default__ = defineComponent({
  name: "TvbSearch"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    fullPath: null
  },
  emits: ["click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const env = inject("env");
    const tvbSearchRef = ref();
    const isClickOutside = useClickOutside(tvbSearchRef);
    ;
    const searchRef = ref();
    const tvbMobileSearchRef = ref();
    const search = reactive({
      isFocus: false,
      keywords: "",
      tags: [],
      searchBlurTimeout: null,
      showMobileSearch: false
    });
    const searchFun = (mobile, event) => {
      if (window.innerWidth <= 768 && !mobile) {
        search.showMobileSearch = true;
      } else if (search.keywords) {
        emits("click", { keyword: search.keywords, event, event_label: "search-keyword" });
      }
    };
    const searchEnter = () => {
      var _a;
      const event = {
        isPreventDefault: false,
        preventDefault: function() {
          this.isPreventDefault = true;
        }
      };
      (_a = searchRef.value) == null ? void 0 : _a.blur();
      emits("click", { keyword: search.keywords, event, event_label: "search-keyword" });
      if (!event.isPreventDefault && search.keywords) {
        window.location.assign(`${PUBLIC_URL(env || "prod")}/search?keyword=${search.keywords}`);
      }
    };
    const searchBlur = () => {
      search.searchBlurTimeout = setTimeout(() => {
        search.isFocus = false;
      }, 200);
    };
    watch(
      () => search.keywords,
      (keywords) => {
        if (keywords) {
          request.get(`/tag?name=${keywords}&page=1&limit=10&_t=${getPublishTimestamp()}`, {
            baseURL: API_BASE(env || "prod")
          }).then(({ data }) => {
            search.tags = (data == null ? void 0 : data.list) || [];
          }).catch(() => {
            search.tags = [];
          });
        } else {
          search.tags = [];
        }
      }
    );
    watch(
      () => props.fullPath,
      () => {
        const { searchParams, pathname } = new URL(location.href);
        if (pathname === "/search") {
          search.keywords = searchParams.get("keyword") || searchParams.get("tag_name") || "";
        } else {
          search.keywords = "";
          search.tags = [];
        }
      }
    );
    watch(
      () => search.showMobileSearch,
      (showMobileSearch) => {
        const htmlel = document.querySelector("html");
        htmlel.style.overflow = showMobileSearch ? "hidden" : "";
        const bodyel = document.querySelector("body");
        bodyel.style.overflow = showMobileSearch ? "hidden" : "";
        nextTick(() => {
          var _a;
          (_a = tvbMobileSearchRef.value) == null ? void 0 : _a.focus();
          setTimeout(() => {
            const bodyel2 = document.querySelector("body");
            bodyel2.style.overflow = showMobileSearch ? "hidden" : "";
          }, 1e3);
        });
      }
    );
    const searchRefFocus = () => {
      var _a;
      clearTimeout(search.searchBlurTimeout);
      (_a = searchRef.value) == null ? void 0 : _a.focus();
    };
    onMounted(() => {
      const { searchParams, pathname } = new URL(location.href);
      if (pathname === "/search") {
        search.keywords = searchParams.get("keyword") || searchParams.get("tag_name") || "";
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "tvbSearchRef",
        ref: tvbSearchRef,
        class: normalizeClass(["tvb-search", { "is-keywords": !!search.keywords }])
      }, [
        createElementVNode("div", {
          class: normalizeClass(["tvb-search-container", { "is-focus": search.isFocus || !!search.keywords, "is-keywords": !!search.keywords }])
        }, [
          withDirectives(createElementVNode("input", {
            id: "tvb-search",
            ref_key: "searchRef",
            ref: searchRef,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => search.keywords = $event),
            type: "search",
            name: "tvb-search",
            class: "tvb-search-input",
            inputautocomplete: "off",
            autocomplete: "off",
            placeholder: search.isFocus ? "" : "\u641C\u5C0B",
            onBlur: searchBlur,
            onFocus: _cache[1] || (_cache[1] = ($event) => search.isFocus = true),
            onKeydown: _cache[2] || (_cache[2] = withKeys(($event) => searchEnter(), ["enter"]))
          }, null, 40, _hoisted_1), [
            [
              vModelText,
              search.keywords,
              void 0,
              { trim: true }
            ]
          ]),
          (openBlock(), createBlock(resolveDynamicComponent(search.keywords ? "a" : "button"), {
            class: "tvb-search-botton",
            href: search.keywords ? `${unref(PUBLIC_URL)(unref(env) || "prod")}/search?keyword=${search.keywords}` : null,
            onClick: _cache[3] || (_cache[3] = (event) => {
              searchRefFocus();
              searchFun(false, event);
            })
          }, {
            default: withCtx(() => [
              !!search.keywords ? (openBlock(), createBlock(TvbSearchWhiteIcon, { key: 0 })) : (openBlock(), createBlock(TvbSearchGreyIcon, { key: 1 }))
            ]),
            _: 1
          }, 8, ["href"])),
          !search.keywords ? (openBlock(), createElementBlock("button", {
            key: 0,
            class: "tvb-search-botton mobile",
            onClick: _cache[4] || (_cache[4] = (event) => {
              searchFun(false, event);
              search.isFocus = false;
            })
          }, [
            createVNode(TvbSearchGreyMIcon)
          ])) : (openBlock(), createElementBlock("div", {
            key: 1,
            class: "tvb-search-input mobile",
            onClick: _cache[5] || (_cache[5] = (event) => {
              searchFun(false, event);
              search.isFocus = false;
            })
          }, toDisplayString(search.keywords), 1))
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(["tvb-search-tags", { show: !!search.tags.length && !unref(isClickOutside) && search.isFocus }])
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(search.tags, (tag, index) => {
            return openBlock(), createElementBlock("a", {
              key: index,
              href: `${unref(PUBLIC_URL)(unref(env) || "prod")}/search?tag=${tag.id}&tag_name=${tag.name}`,
              class: "tvb-search-tag",
              title: tag.name,
              onClick: (event) => emits("click", { ...tag, event, event_label: "search-tag" }),
              innerHTML: tag.name.replaceAll(
                search.keywords,
                `<span style='color: #0062A3;'>${search.keywords}</span>`
              )
            }, null, 8, _hoisted_2);
          }), 128))
        ], 2),
        (openBlock(), createBlock(Teleport, { to: "body" }, [
          withDirectives(createElementVNode("div", {
            class: "tvb-mobile-search",
            onClick: _cache[15] || (_cache[15] = withModifiers(($event) => search.showMobileSearch = false, ["stop"]))
          }, [
            createElementVNode("div", {
              class: "tvb-mobile-search-header",
              onClick: _cache[13] || (_cache[13] = withModifiers(() => {
              }, ["stop"]))
            }, [
              createVNode(TvbLogoIcon, { class: "tvb-mobile-search-logo" }),
              createElementVNode("div", _hoisted_3, [
                withDirectives(createElementVNode("input", {
                  id: "tvb-search",
                  ref_key: "tvbMobileSearchRef",
                  ref: tvbMobileSearchRef,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => search.keywords = $event),
                  type: "search",
                  name: "tvb-search",
                  class: "tvb-mobile-search-input-el",
                  placeholder: search.isFocus ? "" : "\u641C\u5C0B",
                  autofocus: "",
                  onBlur: _cache[7] || (_cache[7] = ($event) => search.isFocus = false),
                  onFocus: _cache[8] || (_cache[8] = ($event) => search.isFocus = true),
                  onKeydown: _cache[9] || (_cache[9] = withKeys(
                    () => {
                      searchEnter();
                      search.showMobileSearch = false;
                    },
                    ["enter"]
                  ))
                }, null, 40, _hoisted_4), [
                  [
                    vModelText,
                    search.keywords,
                    void 0,
                    { trim: true }
                  ]
                ]),
                search.keywords ? (openBlock(), createBlock(TvbClearIcon, {
                  key: 0,
                  class: "tvb-mobile-search-input-clear",
                  onClick: _cache[10] || (_cache[10] = ($event) => search.keywords = "")
                })) : createCommentVNode("v-if", true)
              ]),
              search.keywords ? (openBlock(), createBlock(resolveDynamicComponent(search.keywords ? "a" : "button"), {
                key: 0,
                href: search.keywords ? `${unref(PUBLIC_URL)(unref(env) || "prod")}/search?keyword=${search.keywords}` : null,
                class: "tvb-mobile-search-btn",
                onClick: _cache[11] || (_cache[11] = (event) => {
                  searchFun(true, event);
                  search.showMobileSearch = false;
                })
              }, {
                default: withCtx(() => [
                  createTextVNode(" \u641C\u5C0B ")
                ]),
                _: 1
              }, 8, ["href"])) : (openBlock(), createElementBlock("button", {
                key: 1,
                class: "tvb-mobile-search-cancel",
                onClick: _cache[12] || (_cache[12] = ($event) => search.showMobileSearch = false)
              }, " \u53D6\u6D88 "))
            ]),
            search.tags.length ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "tvb-mobile-search-tags",
              onClick: _cache[14] || (_cache[14] = withModifiers(() => {
              }, ["stop"]))
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(search.tags, (tag, index) => {
                return openBlock(), createElementBlock("a", {
                  key: index,
                  href: `${unref(PUBLIC_URL)(unref(env) || "prod")}/search?tag=${tag.id}`,
                  class: "tvb-mobile-search-tag",
                  title: tag.name,
                  onClick: (event) => {
                    emits("click", { ...tag, event, event_label: "search-tag" });
                    search.showMobileSearch = false;
                  }
                }, [
                  createVNode(TvbSearchGreyMIcon),
                  createElementVNode("p", {
                    innerHTML: tag.name.replaceAll(
                      search.keywords,
                      `<span style='color: #0062A3;'>${search.keywords}</span>`
                    )
                  }, null, 8, _hoisted_6)
                ], 8, _hoisted_5);
              }), 128))
            ])) : createCommentVNode("v-if", true)
          ], 512), [
            [vShow, search.showMobileSearch]
          ])
        ]))
      ], 2);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=index.vue2.mjs.map
